import { Typography } from '@mui/material';
import * as React from 'react';

const sx = () => ({
  fontFamily: 'Avenir Next',
  fontSize: 14,
  fontWeight: 600,
});

function Title() {
  return <Typography sx={sx}>Pause/Unpause Machines</Typography>;
}

export default Title;
